import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SelectInput from '@/corePagesModule/SelectInput/SelectInput.vue';
import { i18n } from '@/i18n';
import { useOrderTableStore } from '@/orderTableModule/pages/useOrderTableStore';
import { storeToRefs } from 'pinia';
import { computed, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderGroupSelectInput',
  props: {
    label: { default: undefined },
    indexNumber: { default: 0 },
    noFetch: { type: Boolean },
    useUniqueModelValue: { type: Boolean },
    propModelValue: { default: undefined }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;
const store = useOrderTableStore();
const { state } = storeToRefs(store);
const { fetchOrderGroup } = store;

const props = __props;
const emits = __emit;

const groupListNames = computed(() =>
  state.value.orderGroupState.groupList.map((group) => group.orderGroupName).filter((groupName) => groupName)
);

const label = computed(() => props.label ?? t('発注グループ名'));

const modelValue = computed(() => props.propModelValue ?? state.value.orderGroupState.targetGroupName);

onMounted(async () => {
  if (!props.noFetch) await fetchOrderGroup();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectInput, {
    index: _ctx.indexNumber,
    "model-value": modelValue.value,
    placeholder: label.value,
    label: label.value,
    "filter-type": "ORDER_GROUP",
    "prop-options": groupListNames.value,
    "use-teleport": "",
    "use-search-input": false,
    "use-reset": false,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = 
      (val) => {
        if (!_ctx.useUniqueModelValue) _unref(state).orderGroupState.targetGroupName = val;
        emits('change', val);
      }
    )
  }, null, 8, ["index", "model-value", "placeholder", "label", "prop-options"]))
}
}

})